import useSession from '@hooks/useSession'
import { useOrgCollectionForm } from '@hooks/useOrgCollectionForm'

export default function useController() {
    const session = useSession()!

    const form = useOrgCollectionForm({
        onSubmit: async (values) => {
            const response = await fetch('/api/ha/v2/org-collections', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${session.accessToken}`,
                },
                body: JSON.stringify(values),
            })

            return response
        },
    })

    return {
        ...form,
    }
}
